(function () {
  'use strict';

  // Spring physics — mirrors motion/react's useSpring behaviour
  function Spring(cfg) {
    this.stiffness = cfg.stiffness || 100;
    this.damping   = cfg.damping   || 30;
    this.mass      = cfg.mass      || 1;
    this.current   = 0;
    this.velocity  = 0;
    this.target    = 0;
  }
  Spring.prototype.set = function (v) { this.target = v; };
  Spring.prototype.step = function (dt) {
    var force = -this.stiffness * (this.current - this.target)
                - this.damping * this.velocity;
    this.velocity += (force / this.mass) * dt;
    this.current  += this.velocity * dt;
    return this.current;
  };
  Spring.prototype.settled = function () {
    return Math.abs(this.current - this.target) < 0.0005 &&
           Math.abs(this.velocity) < 0.0005;
  };

  var MAIN_CFG    = { damping: 30, stiffness: 100, mass: 2 };
  var CAPTION_CFG = { damping: 30, stiffness: 350, mass: 1 };

  function initCard(fig) {
    var inner     = fig.querySelector('.tc-inner');
    var caption   = fig.querySelector('.tc-caption');
    if (!inner) return;

    var amplitude = parseFloat(fig.dataset.amplitude || 12);
    var scaleHover = parseFloat(fig.dataset.scale || 1.08);

    var rX = new Spring(MAIN_CFG);
    var rY = new Spring(MAIN_CFG);
    var sc = new Spring(MAIN_CFG);
    var op = new Spring(MAIN_CFG);
    var rf = new Spring(CAPTION_CFG);

    // Scale starts at 1
    sc.current = sc.target = 1;

    var mx = 0, my = 0, lastOY = 0;
    var hovered = false, raf = null;

    function tick() {
      var dt = 1 / 60;
      rX.step(dt); rY.step(dt); sc.step(dt); op.step(dt); rf.step(dt);

      inner.style.transform =
        'rotateX(' + rX.current + 'deg) ' +
        'rotateY(' + rY.current + 'deg) ' +
        'scale('   + sc.current + ')';

      if (caption) {
        caption.style.transform =
          'translate(' + mx + 'px, ' + my + 'px) rotate(' + rf.current + 'deg)';
        caption.style.opacity = op.current;
      }

      var done = rX.settled() && rY.settled() && sc.settled() &&
                 op.settled() && rf.settled();
      raf = (hovered || !done) ? requestAnimationFrame(tick) : null;
    }

    function go() { if (!raf) raf = requestAnimationFrame(tick); }

    fig.addEventListener('mousemove', function (e) {
      var r  = fig.getBoundingClientRect();
      var ox = e.clientX - r.left - r.width  / 2;
      var oy = e.clientY - r.top  - r.height / 2;

      rX.set((oy / (r.height / 2)) * -amplitude);
      rY.set((ox / (r.width  / 2)) *  amplitude);

      mx = e.clientX - r.left;
      my = e.clientY - r.top;

      rf.set(-(oy - lastOY) * 0.6);
      lastOY = oy;
      go();
    });

    fig.addEventListener('mouseenter', function () {
      hovered = true;
      sc.set(scaleHover);
      op.set(1);
      go();
    });

    fig.addEventListener('mouseleave', function () {
      hovered = false;
      sc.set(1); op.set(0);
      rX.set(0); rY.set(0); rf.set(0);
      go();
    });
  }

  function init() {
    document.querySelectorAll('.tc-figure').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
